// extracted by mini-css-extract-plugin
module.exports = {"NavbarStyles":"Navbar_NavbarStyles__26k2E"};